import EntryThumbnail from "@/src/components/EntryThumbnail";
import clsx from "clsx";

const EntryGrid = ({
  entries,
  size = "lg",
}: {
  entries: any[];
  size?: "lg" | "xl";
}) => {
  return (
    <div className={clsx("EntryGrid", "@container")}>
      <ul
        className={clsx(
          "grid grid-cols-12 gap-x-4 gap-y-4 xs:gap-x-6 xs:gap-y-6"
        )}
      >
        {entries.map((entry) => {
          return (
            <li
              key={entry.id}
              className={clsx(
                "col-span-12 @xs:col-span-6 @md:col-span-6 @lg:col-span-4 @3xl:col-span-3 @7xl:col-span-2"
              )}
            >
              <EntryThumbnail entry={entry} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default EntryGrid;
